import React, { useState } from "react";
import PropTypes from "prop-types";
import { withRouter, useHistory } from "react-router";
import { connect } from "react-redux";

import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
  InputGroupAddon,
  InputGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  FormGroup,
} from "reactstrap";
import Swal from 'sweetalert2'
import { removeHeadersAuthToken } from "../../utils/axios";

import { logoutUser } from "../../actions/auth";
import { closeSidebar, openSidebar } from "../../actions/navigation";
import MenuIcon from "../Icons/HeaderIcons/MenuIcon";
import SearchBarIcon from "../Icons/HeaderIcons/SearchBarIcon";
import SearchIcon from "../Icons/HeaderIcons/SearchIcon";

import logoutIcon from "../../assets/navbarMenus/pfofileIcons/logoutOutlined.svg";

import s from "./Header.module.scss";
import "animate.css";

const Header = (props) => {
  const history = useHistory();
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  const toggleNotifications = () => {
    setNotificationsOpen(!notificationsOpen);
  }

  const toggleSidebar = () => {
    if (props.sidebarOpened) {
      props.dispatch(closeSidebar());
    } else {
      const paths = props.location.pathname.split('/');
      paths.pop();
      props.dispatch(openSidebar());
    }
  }

  const doLogout = () => {
    Swal.fire({
      title: 'Do you want to logout?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Logout',
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        removeHeadersAuthToken()
        props.dispatch(logoutUser());
      }
    })
  }

  return (
    <Navbar className={`${s.root} d-print-none`}>
      <div>
        <NavLink onClick={() => toggleSidebar()} className={`d-md-none mr-3 ${s.navItem}`} href="#">
          <MenuIcon className={s.menuIcon} />
        </NavLink>
      </div>
      <Form className="d-none d-sm-block" inline>
        <FormGroup>
          <InputGroup className='input-group-no-border'>
            <Input id="search-input" placeholder="Search Dashboard" className='focus'/>
            <InputGroupAddon addonType="prepend">
              <span>
                <SearchBarIcon/>
              </span>
            </InputGroupAddon>
          </InputGroup>
        </FormGroup>
      </Form>
      <Nav className="ml-auto">
        <NavItem className="d-sm-none mr-4">
          <NavLink href="#">
            <SearchIcon />
          </NavLink>
        </NavItem>
        <Dropdown isOpen={notificationsOpen} toggle={() => toggleNotifications()} nav id="basic-nav-dropdown" className="ml-3">
          <DropdownToggle nav caret className="navbar-dropdown-toggle">
            <span className={`${s.avatar} rounded-circle float-left mr-2`}>
              <img src={props.user?.photo} alt="User"/>
            </span>
            <span className="small d-none d-sm-block ml-1 mr-2 body-1">{ props.user?.username }</span>
          </DropdownToggle>
          <DropdownMenu className="navbar-dropdown profile-dropdown" style={{ width: "194px" }}>
            <DropdownItem className={s.dropdownProfileItem} onClick={() => history.push("/account")}>
              <i className="eva eva-person-outline" style={{ position: 'relative', top: '5px', color: '#0D3991' }} />
              <span>Account</span>
            </DropdownItem>
            <DropdownItem className={s.dropdownProfileItem} onClick={() => history.push("/account")}>
              <i className="eva eva-settings-outline" style={{ position: 'relative', top: '5px', color: '#0D3991' }} />
              <span>Settings</span>
            </DropdownItem>
            <NavItem>
              <NavLink onClick={() => doLogout()} href="#">
                <button className="btn btn-primary rounded-pill mx-auto logout-btn" type="submit"><img src={logoutIcon} alt="Logout"/><span className="ml-1">Logout</span></button>
              </NavLink>
            </NavItem>
          </DropdownMenu>
        </Dropdown>
      </Nav>
    </Navbar>
  )
}

Header.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sidebarOpened: PropTypes.bool,
}

function mapStateToProps(store) {
  return {
    sidebarOpened: store.navigation.sidebarOpened,
    sidebarStatic: store.navigation.sidebarStatic,
    user: store.auth.user,
  };
}

export default withRouter(connect(mapStateToProps)(Header));

